import createPersistedState from 'use-persisted-state';
const useAllLocalesState = createPersistedState('locales');
const useSelectedLocalesState = createPersistedState('selectedLocale');

const defaultLocales = [
	'en-US',
	'en-GB',
	'cs-CZ',
	'sk-SK',
	'pt-BR',
	'pt-PT',
	'pl-PL',
	'bs-Latn-BA',
	'mk-MK',
	'ru-RU',
	'et-EE',
	'de-DE',
	'it-IT',
	'en-IE',
	'en-CA',
	'hr-HR'
];

export function useAllLocales () {
	return useAllLocalesState(defaultLocales);
}

export function useSelectedLocales () {
	return useSelectedLocalesState(['en-US']);
}
